import {Directive, ElementRef, Output, EventEmitter, OnInit, OnDestroy, inject} from '@angular/core';

@Directive({
  selector: '[appVisibilityObserver]',
  standalone: true
})
export class VisibilityObserverDirective implements OnInit, OnDestroy {
  @Output() visible = new EventEmitter<boolean>();
  private observer: IntersectionObserver | null = null;
  private readonly el: ElementRef = inject(ElementRef);

  ngOnInit() {
    this.observer = new IntersectionObserver(([entry]) => {
      this.visible.emit(entry.isIntersecting);
    }, { threshold: 0.5 });
    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}
